import React from 'react';
import { MapPinIcon } from 'lucide-react';
import { events } from '../data/dashboardData';
export function EventDemand() {
  return <section aria-labelledby="event-title" className="border border-[#d8d2c6] bg-[#fffcf7]" data-id="element-49">
      <div className="border-b border-[#ded8cc] p-4 sm:p-5" data-id="element-50">
        <div className="flex items-end justify-between" data-id="element-51">
          <div data-id="element-52">
            <h2 id="event-title" className="font-serif text-xl text-[#0b2032]" data-id="element-53">
              Local demand signals
            </h2>
            <p className="mt-1 text-xs text-[#73766f]" data-id="element-54">
              Events influencing portfolio pickup
            </p>
          </div>
          <span className="text-[10px] font-bold uppercase tracking-wider text-[#9a7b45]" data-id="element-55">
            Paris
          </span>
        </div>
      </div>
      <div className="divide-y divide-[#e4ded4]" data-id="element-56">
        {events.map(event => <article key={event.title} className="grid grid-cols-[54px_1fr] gap-3 p-4" data-id="element-57">
            <time className="border-r border-[#d8d2c6] pr-3 text-center text-[#0b2032]" data-id="element-58">
              <span className="block font-serif text-lg leading-none" data-id="element-59">
                {event.date}
              </span>
              <span className="mt-1 block text-[9px] font-bold tracking-[0.16em] text-[#9a7b45]" data-id="element-60">
                {event.month}
              </span>
            </time>
            <div data-id="element-61">
              <div className="flex flex-wrap items-start justify-between gap-1" data-id="element-62">
                <h3 className="text-sm font-semibold text-[#132b3d]" data-id="element-63">
                  {event.title}
                </h3>
                <span className="text-[10px] font-semibold text-[#9a5c43]" data-id="element-64">
                  {event.impact} impact
                </span>
              </div>
              <div className="mt-2 flex items-center gap-3 text-[10px] text-[#77766f]" data-id="element-65">
                <span className="font-semibold text-[#34705c]" data-id="element-66">
                  {event.rooms}
                </span>
                <span className="flex items-center gap-1" data-id="element-67">
                  <MapPinIcon size={10} data-id="element-68" /> {event.distance}
                </span>
              </div>
            </div>
          </article>)}
      </div>
    </section>;
}